import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SortSelection from '../SortSelection';
import globalTranslations from '../../../i18n/globalTranslations';
import Icon from '../../common/Icon';
import ProductListStyle from '../../../types/ProductListStyle';

class ProductListTools extends Component {
  getStyleSelect = (icon, selectedStyle) => {
    const { style, onStyleSelect } = this.props;
    return (
      <span
        onClick={() => onStyleSelect(selectedStyle)}
        className="ProductListTools__style-select"
      >
        <Icon className={style === selectedStyle ? 'active' : ''} name={icon} />
      </span>
    );
  };

  render() {
    const {
      countOfProducts,
      onSelectSort,
      selectedSortOrderBy,
      selectedSortOrder,
      showSort
    } = this.props;

    return (
      <div className="ProductListTools">
        <div className="ProductListTools__product-count">
          <FormattedMessage
            {...globalTranslations.productCount}
            values={{ count: countOfProducts }}
          />
        </div>
        {showSort && (
          <SortSelection
            onSelectSort={onSelectSort}
            selectedSortKey={selectedSortOrderBy}
            selectedSortOrder={selectedSortOrder}
          />
        )}
        <div className="ProductListTools__style-selects">
          {this.getStyleSelect('th', ProductListStyle.CARD)}
          {this.getStyleSelect('th-large', ProductListStyle.CARD_LARGE)}
        </div>
      </div>
    );
  }
}

ProductListTools.propTypes = {
  countOfProducts: PropTypes.number,
  selectedSortOrderBy: PropTypes.string,
  selectedSortOrder: PropTypes.string,
  onSelectSort: PropTypes.func,
  style: PropTypes.string,
  onStyleSelect: PropTypes.func.isRequired,
  showSort: PropTypes.bool
};

ProductListTools.defaultProps = {
  showSort: true,
  onSelectSort: () => {}
};

export default ProductListTools;



// WEBPACK FOOTER //
// ./src/components/product-list/ProductListTools/index.jsx